import { encodeFolderPath } from '@opengov/bnp-component-folders/src';
import compact from 'lodash/compact';
import { AvailableTab, ReportingTabId } from '../../../application/common/ReportingTabs/ReportingTabs';

export function buildActionSuccessToastBody(pastTenseVerb: string, infinitiveVerb: string) {
  return (
    succeededReportsCount: number,
    failedReportsCount: number,
    succeededFoldersCount: number,
    failedFoldersCount: number
  ) => {
    const succeededPhrase = getFoldersAndReportsPhrase({
      foldersCount: succeededFoldersCount,
      reportsCount: succeededReportsCount
    });
    const succeededMessage =
      succeededFoldersCount > 0 || succeededReportsCount > 0
        ? `We ${pastTenseVerb} ${succeededPhrase.toLocaleLowerCase()} successfully`
        : '';
    const failedPhrase = getFoldersAndReportsPhrase({
      foldersCount: failedFoldersCount,
      reportsCount: failedReportsCount
    });
    const failedMessage =
      failedFoldersCount > 0 || failedReportsCount > 0
        ? `We were unable to ${infinitiveVerb} your ${failedPhrase.toLocaleLowerCase()}`
        : '';
    return compact([succeededMessage, failedMessage]).join('. ');
  };
}

export function buildActionErrorToastBody(infinitiveVerb: string) {
  return (failedReportsCount: number, failedFoldersCount: number) => {
    const failedPhrase = getFoldersAndReportsPhrase({
      foldersCount: failedFoldersCount,
      reportsCount: failedReportsCount
    });
    return failedFoldersCount > 0 || failedReportsCount > 0
      ? `We were unable to ${infinitiveVerb} your ${failedPhrase.toLocaleLowerCase()}`
      : '';
  };
}

export const PageEvents = {
  CreateFolder: 'Reporting: Create Folder',
  MoveFolders: 'Reporting: Move Folders',
  DuplicateReports: 'Reporting: Duplicate Reports',
  DeleteFolders: 'Reporting: Delete Folders'
};

const intl = {
  folder: 'Folder',
  folders: (count: number) => `${count} Folders`,
  report: 'Report',
  reports: (count: number) => `${count} Reports`,
  and: 'and'
};

export function getFoldersAndReportsPhrase({
  foldersCount,
  reportsCount
}: {
  foldersCount: number;
  reportsCount: number;
}) {
  let foldersPart = '';
  let reportsPart = '';
  if (foldersCount > 0) {
    foldersPart = foldersCount === 1 ? intl.folder : intl.folders(foldersCount);
  }
  if (reportsCount > 0) {
    reportsPart = reportsCount === 1 ? intl.report : intl.reports(reportsCount);
  }
  return compact([foldersPart, reportsPart]).join(` ${intl.and} `);
}

export function folderRoute(entitySubdomain: string, folderPath: string[]) {
  return `/${entitySubdomain}/folders/${encodeFolderPath(folderPath)}`;
}

const PSP_AVAILABLE_TABS = [ReportingTabId.NewReportTab];
export function getPsPAvailableTabs(availableTabs: AvailableTab[]) {
  return availableTabs.filter((tab) => PSP_AVAILABLE_TABS.includes(tab.id));
}
